import type { PersonInvolvement } from "../types/involvement.js";
import { hasInvolvementEnded } from "./hasInvolvementEnded.js";

/**
 * Whether an involvement conveys anything at this instant. The server's
 * `isLiveNow` states the same in SQL; change both together.
 */
export const isInvolvementLive = (
  involvement: Pick<PersonInvolvement, "endedAt" | "expiresAt">,
  now: Date = new Date(),
): boolean =>
  !hasInvolvementEnded(involvement, now) &&
  (involvement.expiresAt === null || involvement.expiresAt > now);
